export const useLocalCache = () => {
  const LOCAL_DATA_CACHE = {
    DICTIONARY_MAPPINGS: {
      list: [
        {
          "type": "ecCountry",
          "list": [
            {
              "id": 39,
              "type": "ecCountry",
              "value": "HK",
              "cnName": "中国香港",
              "twName": "中國香港",
              "enName": "Hong Kong",
              "vnName": "Hồng Kông",
              "parentId": null,
              "description": null,
              "sort": 1,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 42,
              "type": "ecCountry",
              "value": "SG",
              "cnName": "新加坡",
              "twName": "新加坡",
              "enName": "Singapore",
              "vnName": "Singapore",
              "parentId": null,
              "description": null,
              "sort": 2,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 41,
              "type": "ecCountry",
              "value": "ID",
              "cnName": "印尼",
              "twName": "印尼",
              "enName": "Indonesia",
              "vnName": "Indonesia",
              "parentId": null,
              "description": null,
              "sort": 3,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 44,
              "type": "ecCountry",
              "value": "TH",
              "cnName": "泰国",
              "twName": "泰國",
              "enName": "Thailand",
              "vnName": "Thái Lan",
              "parentId": null,
              "description": null,
              "sort": 4,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 43,
              "type": "ecCountry",
              "value": "PH",
              "cnName": "菲律宾",
              "twName": "菲律賓",
              "enName": "Philippines",
              "vnName": "Philippines",
              "parentId": null,
              "description": null,
              "sort": 5,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 40,
              "type": "ecCountry",
              "value": "JP",
              "cnName": "日本",
              "twName": "日本",
              "enName": "Japan",
              "vnName": "Nhật Bản",
              "parentId": null,
              "description": null,
              "sort": 6,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 47,
              "type": "ecCountry",
              "value": "AU",
              "cnName": "澳大利亚",
              "twName": "澳大利亞",
              "enName": "Australia",
              "vnName": "Úc",
              "parentId": null,
              "description": null,
              "sort": 7,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 38,
              "type": "ecCountry",
              "value": "US",
              "cnName": "美国",
              "twName": "美國",
              "enName": "United States",
              "vnName": "Mỹ",
              "parentId": null,
              "description": null,
              "sort": 8,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 49,
              "type": "ecCountry",
              "value": "CA",
              "cnName": "加拿大",
              "twName": "加拿大",
              "enName": "Canada",
              "vnName": "Canada",
              "parentId": null,
              "description": null,
              "sort": 9,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 48,
              "type": "ecCountry",
              "value": "MX",
              "cnName": "墨西哥",
              "twName": "墨西哥",
              "enName": "Mexico",
              "vnName": "Mexico",
              "parentId": null,
              "description": null,
              "sort": 10,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 36,
              "type": "ecCountry",
              "value": "EE",
              "cnName": "欧洲",
              "twName": "歐洲",
              "enName": "Europe",
              "vnName": "Châu Âu",
              "parentId": null,
              "description": null,
              "sort": 11,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 37,
              "type": "ecCountry",
              "value": "GB",
              "cnName": "英国",
              "twName": "英國",
              "enName": "United Kingdom",
              "vnName": "Anh Quốc",
              "parentId": null,
              "description": null,
              "sort": 12,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 3844,
              "type": "ecCountry",
              "value": "AE",
              "cnName": "阿联酋",
              "twName": "阿聯酋",
              "enName": "United Arab Emirates",
              "vnName": "Các tiểu vương quốc Ả Rập thống nhất",
              "parentId": null,
              "description": null,
              "sort": 13,
              "status": "1",
              "createTime": "2024-07-16T11:06:46",
              "lastTime": "2024-07-16T11:06:47"
            }
          ]
        },
        {
          "type": "ecPlatform",
          "list": [
            {
              "id": 1,
              "type": "ecPlatform",
              "value": "01",
              "cnName": "Amazon",
              "twName": "Amazon",
              "enName": "Amazon",
              "vnName": "Amazon",
              "parentId": null,
              "description": null,
              "sort": 1,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 33,
              "type": "ecPlatform",
              "value": "93",
              "cnName": "Amazon VC",
              "twName": "Amazon VC",
              "enName": "Amazon VC",
              "vnName": "Amazon VC",
              "parentId": null,
              "description": null,
              "sort": 2,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 2,
              "type": "ecPlatform",
              "value": "02",
              "cnName": "eBay",
              "twName": "eBay",
              "enName": "eBay",
              "vnName": "eBay",
              "parentId": null,
              "description": null,
              "sort": 3,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 3,
              "type": "ecPlatform",
              "value": "03",
              "cnName": "Yahoo",
              "twName": "Yahoo",
              "enName": "Yahoo",
              "vnName": "Yahoo",
              "parentId": null,
              "description": null,
              "sort": 4,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 4,
              "type": "ecPlatform",
              "value": "04",
              "cnName": "fril",
              "twName": "fril",
              "enName": "fril",
              "vnName": "fril",
              "parentId": null,
              "description": null,
              "sort": 5,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 5,
              "type": "ecPlatform",
              "value": "05",
              "cnName": "Mercari",
              "twName": "Mercari",
              "enName": "Mercari",
              "vnName": "Mercari",
              "parentId": null,
              "description": null,
              "sort": 6,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 6,
              "type": "ecPlatform",
              "value": "06",
              "cnName": "wish",
              "twName": "wish",
              "enName": "wish",
              "vnName": "wish",
              "parentId": null,
              "description": null,
              "sort": 7,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 7,
              "type": "ecPlatform",
              "value": "07",
              "cnName": "walMart",
              "twName": "walMart",
              "enName": "walMart",
              "vnName": "walMart",
              "parentId": null,
              "description": null,
              "sort": 8,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 8,
              "type": "ecPlatform",
              "value": "08",
              "cnName": "airbnb",
              "twName": "airbnb",
              "enName": "airbnb",
              "vnName": "airbnb",
              "parentId": null,
              "description": null,
              "sort": 9,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 9,
              "type": "ecPlatform",
              "value": "09",
              "cnName": "Shopify",
              "twName": "Shopify",
              "enName": "Shopify",
              "vnName": "Shopify",
              "parentId": null,
              "description": null,
              "sort": 10,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 10,
              "type": "ecPlatform",
              "value": "10",
              "cnName": "AliExpress",
              "twName": "AliExpress",
              "enName": "AliExpress",
              "vnName": "AliExpress",
              "parentId": null,
              "description": null,
              "sort": 11,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 11,
              "type": "ecPlatform",
              "value": "11",
              "cnName": "Google Play",
              "twName": "Google Play",
              "enName": "Google Play",
              "vnName": "Google Play",
              "parentId": null,
              "description": null,
              "sort": 12,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 12,
              "type": "ecPlatform",
              "value": "12",
              "cnName": "App Store",
              "twName": "App Store",
              "enName": "App Store",
              "vnName": "App Store",
              "parentId": null,
              "description": null,
              "sort": 13,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 13,
              "type": "ecPlatform",
              "value": "13",
              "cnName": "cdiscount",
              "twName": "cdiscount",
              "enName": "cdiscount",
              "vnName": "cdiscount",
              "parentId": null,
              "description": null,
              "sort": 14,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 14,
              "type": "ecPlatform",
              "value": "14",
              "cnName": "newEgg",
              "twName": "newEgg",
              "enName": "newEgg",
              "vnName": "newEgg",
              "parentId": null,
              "description": null,
              "sort": 15,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 23,
              "type": "ecPlatform",
              "value": "23",
              "cnName": "TikTok",
              "twName": "TikTok",
              "enName": "TikTok",
              "vnName": "TikTok",
              "parentId": null,
              "description": null,
              "sort": 16,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 16,
              "type": "ecPlatform",
              "value": "16",
              "cnName": "Bukalapak",
              "twName": "Bukalapak",
              "enName": "Bukalapak",
              "vnName": "Bukalapak",
              "parentId": null,
              "description": null,
              "sort": 17,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 18,
              "type": "ecPlatform",
              "value": "18",
              "cnName": "Shopee",
              "twName": "Shopee",
              "enName": "Shopee",
              "vnName": "Shopee",
              "parentId": null,
              "description": null,
              "sort": 18,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 19,
              "type": "ecPlatform",
              "value": "19",
              "cnName": "DHgate",
              "twName": "DHgate",
              "enName": "DHgate",
              "vnName": "DHgate",
              "parentId": null,
              "description": null,
              "sort": 19,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 20,
              "type": "ecPlatform",
              "value": "20",
              "cnName": "Lazada",
              "twName": "Lazada",
              "enName": "Lazada",
              "vnName": "Lazada",
              "parentId": null,
              "description": null,
              "sort": 20,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 21,
              "type": "ecPlatform",
              "value": "21",
              "cnName": "Shoplazza",
              "twName": "Shoplazza",
              "enName": "Shoplazza",
              "vnName": "Shoplazza",
              "parentId": null,
              "description": null,
              "sort": 21,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 22,
              "type": "ecPlatform",
              "value": "22",
              "cnName": "eMAG",
              "twName": "eMAG",
              "enName": "eMAG",
              "vnName": "eMAG",
              "parentId": null,
              "description": null,
              "sort": 22,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 15,
              "type": "ecPlatform",
              "value": "15",
              "cnName": "WayFair",
              "twName": "WayFair",
              "enName": "WayFair",
              "vnName": "WayFair",
              "parentId": null,
              "description": null,
              "sort": 23,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 24,
              "type": "ecPlatform",
              "value": "24",
              "cnName": "Shopline",
              "twName": "Shopline",
              "enName": "Shopline",
              "vnName": "Shopline",
              "parentId": null,
              "description": null,
              "sort": 24,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 25,
              "type": "ecPlatform",
              "value": "25",
              "cnName": "Tokopedia",
              "twName": "Tokopedia",
              "enName": "Tokopedia",
              "vnName": "Tokopedia",
              "parentId": null,
              "description": null,
              "sort": 25,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 30,
              "type": "ecPlatform",
              "value": "ET",
              "cnName": "ET",
              "twName": "ET",
              "enName": "ET",
              "vnName": "ET",
              "parentId": null,
              "description": null,
              "sort": 26,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 35,
              "type": "ecPlatform",
              "value": "96",
              "cnName": "物流服务",
              "twName": "物流服務",
              "enName": "Logistics",
              "vnName": "Logistics",
              "parentId": null,
              "description": null,
              "sort": 28,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 50,
              "type": "ecPlatform",
              "value": "94",
              "cnName": "服务贸易",
              "twName": "服務貿易",
              "enName": "Service Trade",
              "vnName": "Dịch vụ thương mại",
              "parentId": null,
              "description": null,
              "sort": 29,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 26,
              "type": "ecPlatform",
              "value": "97",
              "cnName": "其他应用",
              "twName": "其他應用",
              "enName": "Other Applications",
              "vnName": "Các ứng dụng khác",
              "parentId": null,
              "description": null,
              "sort": 30,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 27,
              "type": "ecPlatform",
              "value": "98",
              "cnName": "B2B贸易",
              "twName": "B2B貿易",
              "enName": "B2B Goods Trade",
              "vnName": "Bán hàng B2B",
              "parentId": null,
              "description": null,
              "sort": 31,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 28,
              "type": "ecPlatform",
              "value": "99",
              "cnName": "独立站",
              "twName": "獨立站",
              "enName": "DTC Brand",
              "vnName": "Doanh nghiệp D2C",
              "parentId": null,
              "description": null,
              "sort": 32,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 3818,
              "type": "ecPlatform",
              "value": "26",
              "cnName": "Etsy",
              "twName": "Etsy",
              "enName": "Etsy",
              "vnName": "Etsy",
              "parentId": null,
              "description": null,
              "sort": 33,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3819,
              "type": "ecPlatform",
              "value": "27",
              "cnName": "TEMU",
              "twName": "TEMU",
              "enName": "TEMU",
              "vnName": "TEMU",
              "parentId": null,
              "description": null,
              "sort": 34,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 17,
              "type": "ecPlatform",
              "value": "17",
              "cnName": "Mercado Libre",
              "twName": "Mercado Libre",
              "enName": "Mercado Libre",
              "vnName": "Mercado Libre",
              "parentId": null,
              "description": null,
              "sort": 35,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 3823,
              "type": "ecPlatform",
              "value": "31",
              "cnName": "SHEIN",
              "twName": "SHEIN",
              "enName": "SHEIN",
              "vnName": "SHEIN",
              "parentId": null,
              "description": null,
              "sort": 36,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3820,
              "type": "ecPlatform",
              "value": "28",
              "cnName": "Agoda",
              "twName": "Agoda",
              "enName": "Agoda",
              "vnName": "Agoda",
              "parentId": null,
              "description": null,
              "sort": 37,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3821,
              "type": "ecPlatform",
              "value": "29",
              "cnName": "Expedia",
              "twName": "Expedia",
              "enName": "Expedia",
              "vnName": "Expedia",
              "parentId": null,
              "description": null,
              "sort": 38,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3822,
              "type": "ecPlatform",
              "value": "30",
              "cnName": "Trip.com",
              "twName": "Trip.com",
              "enName": "Trip.com",
              "vnName": "Trip.com",
              "parentId": null,
              "description": null,
              "sort": 39,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3824,
              "type": "ecPlatform",
              "value": "32",
              "cnName": "天猫国际",
              "twName": "天猫國際",
              "enName": "Tmall Global",
              "vnName": "Tmall",
              "parentId": null,
              "description": null,
              "sort": 40,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3825,
              "type": "ecPlatform",
              "value": "33",
              "cnName": "京东国际",
              "twName": "京東國際",
              "enName": "JD International",
              "vnName": "JingDong Mall",
              "parentId": null,
              "description": null,
              "sort": 41,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3826,
              "type": "ecPlatform",
              "value": "34",
              "cnName": "多多国际",
              "twName": "多多國際",
              "enName": "Pinduoduo International",
              "vnName": "Pinduoduo ",
              "parentId": null,
              "description": null,
              "sort": 42,
              "status": "1",
              "createTime": "2024-06-03T17:33:41",
              "lastTime": "2024-06-03T17:33:41"
            },
            {
              "id": 3829,
              "type": "ecPlatform",
              "value": "37",
              "cnName": "广告服务",
              "twName": "廣告服務",
              "enName": "Advertising Services",
              "vnName": "Dịch vụ quảng cáo",
              "parentId": null,
              "description": null,
              "sort": 43,
              "status": "1",
              "createTime": "2024-06-03T17:33:42",
              "lastTime": "2024-06-03T17:33:42"
            },
            {
              "id": 3830,
              "type": "ecPlatform",
              "value": "38",
              "cnName": "技术服务",
              "twName": "技術服務",
              "enName": "Technical Services",
              "vnName": "Dịch vụ kỹ thuật",
              "parentId": null,
              "description": null,
              "sort": 44,
              "status": "1",
              "createTime": "2024-06-03T17:33:42",
              "lastTime": "2024-06-03T17:33:42"
            },
            {
              "id": 3831,
              "type": "ecPlatform",
              "value": "39",
              "cnName": "Meituan",
              "twName": "Meituan",
              "enName": "Meituan",
              "vnName": "Meituan",
              "parentId": null,
              "description": null,
              "sort": 45,
              "status": "1",
              "createTime": "2024-06-03T17:33:42",
              "lastTime": "2024-06-03T17:33:42"
            },
            {
              "id": 32,
              "type": "ecPlatform",
              "value": "92",
              "cnName": "进口电商",
              "twName": "進口電商",
              "enName": "E-commerce Import",
              "vnName": "Nhập khẩu TMĐT",
              "parentId": null,
              "description": null,
              "sort": 46,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 34,
              "type": "ecPlatform",
              "value": "95",
              "cnName": "航旅服务",
              "twName": "航旅服務",
              "enName": "OTA",
              "vnName": "Dịch vụ du lịch trực tuyến",
              "parentId": null,
              "description": null,
              "sort": 47,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            },
            {
              "id": 29,
              "type": "ecPlatform",
              "value": "00",
              "cnName": "其他电商平台",
              "twName": "其他電商平台",
              "enName": "Other E-Commerce Platforms",
              "vnName": "Các nền tảng TMĐT khác",
              "parentId": null,
              "description": null,
              "sort": 48,
              "status": "1",
              "createTime": "2024-02-23T11:26:37",
              "lastTime": "2024-02-23T11:26:37"
            }
          ]
        }
      ]
    }
  }

  return {
    LOCAL_DATA_CACHE
  }
}
